// store/index.ts
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'

// 必须在创建 store 实例之前调用
Vue.use(Vuex)

// 现在可以创建 store 实例
const store = new Vuex.Store({
  modules: {
    auth
  }
})

export default store